<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>

    <b-row>
      <b-col cols="12" md="2">
        <b-form-group>
          <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
        </b-form-group>
      </b-col>

      <b-col cols="12" md="2">
        <b-form-group>
          <b-form-select
            v-model="filter.status"
            :options="options.status"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="2">
        <b-form-group>
          <b-form-select
            v-model="filter.transfer_status"
            :options="options.status_transfer"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="2">
        <b-form-group>
          <v-select id="v-toko" v-model="filter.sales_id" label="name" :options="options.sales" placeholder="Filter data by sales"
          :reduce="(options) => options.id" @search="onSearchSales" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <div class="row justify-content-end mb-1">
          <div class="col-9">
            <button class="btn btn-primary btn-block" @click="exportData()">
              Export
            </button>
          </div>
        </div>
        <!-- <h6 class="text-right">Xendit Balance: <span class="text-primary font-weight-bolder">{{ xenditBalance | formatAmount }}</span></h6> -->
      </b-col>
    </b-row>

    <b-card-code no-body>
      <div class="table-responsive-sm" style="overflow-x: auto">
        <table class="table b-table table-fixed">
          <thead>
            <tr>
              <th>Sales</th>
              <th>Jumlah</th>
              <th>Status</th>
              <th>Tanggal</th>
              <th>Status Transfer</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-if="isLoading">
              <td colspan="5" class="text-center">
                <b-spinner label="Loading..." variant="primary" />
              </td>
            </tr>
            <tr v-for="item in result.data" v-if="!isLoading" :key="item">
              <td class="text-capitalize">{{ item.user.name + ' - ' + item.user.phone }}</td>
              <td>{{ formatAmount(item.amount) }}</td>
              <td class="text-capitalize">
                {{ item.status }}
              </td>
              <td>{{ item.created_at }}</td>
              <td class="text-capitalize">{{ item.transfer_status }}</td>
              <td class="text-right">
                <div class="btn-group" role="group" aria-label="Basic example">

                  <button class="btn btn-info btn-sm" style="margin-left: 2px;" data-toggle="tooltip"
                    data-placement="top" title="Detail" @click="detailItem(item)">
                    <feather-icon icon="EyeIcon" />
                  </button>

                  <button v-if="item.status == 'pending'" class="btn btn-success btn-sm" style="margin-left: 2px;"
                    data-toggle="tooltip" data-placement="top" title="Approve" @click="approve(item.uuid)">
                    <feather-icon icon="CheckCircleIcon" />
                  </button>

                  <button v-if="item.status == 'pending'" class="btn btn-danger btn-sm" style="margin-left: 2px;"
                    data-toggle="tooltip" data-placement="top" title="Reject" @click="reject(item.uuid)">
                    <feather-icon icon="XCircleIcon" />
                  </button>

                </div>
              </td>
            </tr>
            <tr v-if="result.total == 0 && !isLoading">
              <td colspan="5" class="text-center">
                Data is empty.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row mt-1">
          <div class="col-6 pl-2">
            <small>Showing {{ result.from }} to {{ result.to }} from {{ result.total }}</small>
          </div>
          <div class="col-6 pr-2">
            <pagination :data="result" :limit="4" align="right" @pagination-change-page="getData" />
          </div>
        </div>
      </div>
    </b-card-code>

    <!-- Detail Modal -->
    <b-modal id="detail-modal" no-close-on-backdrop size="lg" title="Detail">
      <table v-if="detail != null" class="table table-hover">
        <tr>
          <td>ID</td>
          <td>{{ detail.formatted_id }}</td>
        </tr>
        <tr>
          <td>Jumlah</td>
          <td>{{ formatAmount(detail.amount) }}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td style="text-transform: capitalize;">
            {{ detail.status }}
          </td>
        </tr>
        <tr>
          <td>Sales</td>
          <td>{{ detail.user.name + ' - ' + detail.user.phone }}</td>
        </tr>
        <tr>
          <td>Transfer Status</td>
          <td class="text-capitalize">{{ detail.transfer_status }}</td>
        </tr>
        <tr>
          <td>Transfer Message</td>
          <td>{{ detail.transfer_message || '-' }}</td>
        </tr>
        <tr>
          <td>Transfer Fee</td>
          <td>{{ detail.transfer_fee_amount | formatAmount }}</td>
        </tr>
        <tr>
          <td>Transfer Total</td>
          <td>{{ detail.total | formatAmount }}</td>
        </tr>
        <tr>
          <td>Rekening Pembayaran</td>
          <td v-if="detail.payment_account">
            Nama Bank: {{ detail.payment_account.account_bank_name }} <br>
            Nomor Rekening: {{ detail.payment_account.account_number }} <br>
            Nama Pemilik Rekening: {{ detail.payment_account.account_holder_name }}
          </td>
          <td v-else>
            <span>-</span>
          </td>
        </tr>
      </table>
    </b-modal>
    <!-- Detail Modal -->
  </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BCardText, BButton, BDropdown, BDropdownItem, BSpinner,
  BFormGroup, BFormSelect, BRow, BCol,
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import Vue from 'vue'
import VuejsDialog from 'vuejs-dialog'
import FileSaver from 'file-saver'
import axios from 'axios'
import vSelect from "vue-select";

import 'vuejs-dialog/dist/vuejs-dialog.min.css'

Vue.use(VuejsDialog)

export default {
  title() {
    return 'Withdraw'
  },
  components: {
    BFormGroup,
    BCard,
    BButton,
    BCardText,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BSpinner, 
    BFormSelect,
    vSelect,
    BRow,
    BCol,
  },
  watch: {
    filter: {
      handler: _.debounce(function () {
        this.getData()
      }, 300),
      deep: true,
    },
  },
  setup(props) {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    }
  },
  data() {
    return {
      currentPage: 1,
      result: Object,
      isLoading: false,
      detail: null,
      filter: {
        search: '',
        status: null,
        transfer_status: null,
        sales_id: null,
      },
      xenditBalance: 0,
      options: {
        status: [
          { value: null, text: 'Filter data by status' },
          { value: 'success', text: 'Success' },
          { value: 'pending', text: 'Pending' },
          { value: 'rejected', text: 'Rejected' },
        ],
        status_transfer: [
          { value: null, text: 'Filter data by status transfer' },
          { value: 'success', text: 'Success' },
          { value: 'pending', text: 'Pending' },
          { value: 'failed', text: 'Failed' },
        ],
        sales: [],
      }
    }
  },
  created() {
    this.getData()
    this.getSales()
  },
  async mounted() {
    // try {
    //   const response = await this.$http.get('/super-admin/xendit-balance')
    //   this.xenditBalance = response.data.data || 0
    // } catch (error) {
      
    // }
  },
  methods: {
    onSearchSales(search, loading) {
      if (search.length) {
        loading(true);
        this.searchToko(loading, search, this);
      } else {
        loading(true);
        setTimeout(() => {
          this.options.sales = [];
          this.getDataToko();
          loading(false);
        }, 500);
      }
    },
    searchSales: _.debounce((loading, search, vm) => {
      vm.$http.get('/super-admin/sales', {
        params: {
          search,
        },
      }).then((response) => {
        vm.options.sales = response.data;
        loading(false);
      });
    }, 300),
    getSales(page = 1) {
      this.$http.get('/super-admin/sales')
        .then(response => {
          this.options.sales = response.data.data.data
        })
    },
    exportData(type = 'excel') {
      const context = this
      const axiosSource = axios.CancelToken.source()
      this.request = { cancel: axiosSource.cancel, msg: 'Loading...' }

      this.$http.get('super-admin/withdraw-export', {
        responseType: type == 'view' ? '' : 'blob',
        params: this.filter,
        cancelToken: axiosSource.token,
      }).then(response => {
        var timestamp = Math.floor(Date.now() / 1000)
        if (type == 'view') {
          context.contentHtml = response.data.data.html
        } else {
          var timestamp = Math.floor(Date.now() / 1000)
          if (type == 'excel') {
            var fileName = `withdraw-export-${timestamp}.xlsx`
            FileSaver.saveAs(response.data, fileName)
          }

          if (type == 'pdf') {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            var fileName = `withdraw-export-${timestamp}.pdf`
            FileSaver.saveAs(blob, fileName)
          }
        }

        context.isLoading = false
      }).catch(error => {
        context.isLoading = false

        if (error.response.data.meta.messages.length > 0) {
          errorNotification(this, 'Oops!', error.response.data.meta.messages)
        }
      })
    },
    formatAmount(value) {
      if (typeof value !== 'number') {
        return value
      }
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      })
      return formatter.format(value).replace(/^(\D+)/, 'Rp ')
    },
    detailItem(item) {
      this.detail = item

      this.$bvModal.show('detail-modal')
    },
    getData(page = 1) {
      this.isLoading = true
      this.currentPage = page
      const queryParams = this.filter
      queryParams.page = this.currentPage

      this.$http.get('/super-admin/withdraw', {
        params: queryParams,
      })
        .then(response => {
          this.result = response.data.data
          this.isLoading = false
        })
    },
    approve(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Are you sure to approve this withdraw?',
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.post(`super-admin/withdraw/${id}/approve`)
            .then(response => {
              this.getData(this.currentPage)
              this.$swal({
                icon: 'success',
                title: 'Success!',
                text: 'Withdraw successfully approved',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .catch(error => {
              if (error.response.data.meta.messages.length > 0) {
                errorNotification(this, 'Oops!', error.response.data.meta.messages)
              }
            })
        }
      })
    },
    reject(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Are you sure to reject this withdraw?',
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.post(`super-admin/withdraw/${id}/reject`)
            .then(response => {
              this.getData(this.currentPage)
              this.$swal({
                icon: 'success',
                title: 'Success!',
                text: 'Withdraw successfully rejected',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .catch(error => {
              if (error.response.data.meta.messages.length > 0) {
                errorNotification(this, 'Oops!', error.response.data.meta.messages)
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
